import Hero from "../components/home/Hero";
import MachineryShowcase from "../components/sections/MachineryShowcase";
import ServicesGrid from "../components/sections/ServicesGrid";
import ProductsShowcase from "../components/sections/ProductsShowcase";
import ProcessTimeline from "../components/sections/ProcessTimeline";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import Customers from "../components/sections/Customers";
import CTASection from "../components/sections/CTASection";
import Seo from "../components/Seo";

const Home = () => {
  return (
    <div data-testid="home-page">
      <Seo
        title="Precision Sheet Metal Manufacturing"
        description="PAHI TECHNOCRATE PVT. LTD. — ISO-certified precision sheet metal manufacturing, fabrication & machining components in Neemrana, Rajasthan. Advanced Japanese machinery for OEM, HVAC, Automotive, EV, Electrical & Telecom industries."
        path="/"
      />
      <Hero />
      <MachineryShowcase />
      <ServicesGrid preview />
      <ProductsShowcase preview />
      <ProcessTimeline />
      <WhyChooseUs />
      <Customers />
      <CTASection />
    </div>
  );
};

export default Home;
